<template>
	<div class="Rlist_wrap"><!-- Rlist_wrap -->
		<h1><img src="images/tit_gltj.png"  alt=""/></h1>
		
		<dl class="Rlist">
			<dt v-for="(item,index) in relatedata">
				<i></i>
				<router-link :to="{ name: 'detail', params: { id: item.id }}">{{item.articletitle}}</router-link>
			</dt>
			<!-- <dt><i></i><a href="">SWIFT制裁之下，原油价格如何展望？</a></dt>
			<dt><i></i><a href="">俄乌冲突思考：当西方全面制裁时会发生什么？</a></dt>
			<dt><i></i><a href="">俄乌冲突仅是导火索，粮价飙升早有端倪</a></dt>
			<dt><i></i><a href="">西方制裁再升级，要动底牌？</a></dt>
			<dt><i></i><a href="">制裁俄能源的众生相：美英壮士断腕？非也</a></dt> -->
		</dl>
		
	</div><!-- /Rlist_wrap -->
</template>

<script>
	export default{
		data() {
			return{
				
			}
		},
		props:[
			'relatedata'
		],
	}
</script>

<style>
</style>
